import React from 'react';

const FormGroup = ({children}) => {
    return (
        <div className="my-20 flex flex-col md:grid grid-cols-12 gap-8 gap-y-10">
            {children}
        </div>
    );
};

export default FormGroup;
